var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCadastroPremiado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#a51713",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350 964 c-160 -69 -159 -291 2 -359 47 -19 99 -19 146 0 161 68 161 292 0 360 -47 19 -103 19 -148 -1z m148 -54 c95 -58 95 -191 0 -251 -25 -15 -45 -19 -84 -16 -86 6 -134 58 -134 146 0 42 5 56 32 87 18 20 41 40 52 44 38 15 100 11 134 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 587 c-2 -7 27 -80 65 -162 l70 -149 -29 -18 c-97 -58 -90 -191 12 -244 34 -18 70 -18 113 0 47 20 75 69 75 130 0 43 -4 53 -37 86 -21 20 -44 39 -52 42 -11 3 1 38 52 147 70 149 80 185 50 179 -20 -4 -24 -10 -97 -168 l-54 -115 -37 80 c-21 44 -50 108 -66 143 -27 60 -53 79 -65 49z m210 -368 c14 -7 32 -27 41 -46 14 -29 15 -40 4 -64 -38 -93 -169 -70 -169 30 0 32 6 44 31 65 34 29 55 32 93 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 514 c-155 -42 -283 -190 -297 -344 -6 -61 -6 -62 18 -58 21 3 25 10 31 60 14 114 97 225 206 276 49 23 70 27 147 27 65 0 105 -5 143 -20 46 -17 54 -17 63 -5 14 23 -22 46 -101 64 -84 19 -138 19 -210 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCadastroPremiado);
export default __webpack_public_path__ + "static/media/icon_cadastro_premiado.69715d25a910c7078e1125b96d573b9e.svg";
export { ForwardRef as ReactComponent };